module.exports = __webpack_public_path__ + "static/electrum-765af057b94337e17ac3029b43ae90a5.png";